function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import React, { PureComponent } from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import gettext from 'js-utils/gettext';
import lazyGettext from 'js-utils/lazy-gettext';
import UploaderLayoutManager from '../uploader/UploaderLayoutManager';
import ProgressIndicator from '../progressIndicator/ProgressIndicator';
import PreviewElement from './imageUploaderPreview';
import ObjectFitImage from './ObjectFitImage';
import { isPromise } from '../uploader/utils';
import { mbToBytes, isFileSizeValid, isFileTypeValid, IMAGE_CONTENT_TYPES } from '../utils/file';
import Icon from '../icon/Icon';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';
import { loadImageFileDataURL } from './utils';
import { IMAGE_DROPZONE_DEFAULT_ICON_COLOR, IMAGE_DROPZONE_ACTIVE_ICON_COLOR, IMAGE_DROPZONE_ERROR_ICON_COLOR, UPLOAD_STATUS_FAILED, UPLOAD_STATUS_SUCCESS, UPLOAD_STATUS_UPLOADING } from './constants';
import PhotoSvg from '../iconography/icons/Photo';

var defaultAllowedContentTypes = _toConsumableArray(IMAGE_CONTENT_TYPES);
/**
 * The element shown when the uploader is awaiting interaction
 */


var DropzoneElement = function DropzoneElement(_ref) {
  var headline = _ref.headline,
      description = _ref.description,
      iconType = _ref.iconType,
      iconAnimated = _ref.iconAnimated,
      isActive = _ref.isActive,
      errorContent = _ref.errorContent;
  var dropzoneClassName = classNames({
    'eds-image-uploader__dropzone--active': isActive,
    'eds-image-uploader__dropzone--error': errorContent
  }, 'eds-image-uploader__dropzone');
  var iconColor = IMAGE_DROPZONE_DEFAULT_ICON_COLOR;
  var content = description;

  if (errorContent) {
    content = '';
    iconColor = IMAGE_DROPZONE_ERROR_ICON_COLOR;
  }

  if (isActive) {
    iconColor = IMAGE_DROPZONE_ACTIVE_ICON_COLOR;
  }

  return React.createElement("div", {
    className: dropzoneClassName,
    "data-spec": "image-uploader-dropzone-element"
  }, React.createElement(Icon, {
    type: iconType,
    color: iconColor,
    isBlockLevel: true,
    animated: !!iconAnimated,
    size: "medium"
  }), React.createElement("div", {
    className: "eds-image-uploader__dropzone-headline eds-text-bl",
    "data-spec": "image-uploader-headline"
  }, headline), React.createElement("div", {
    className: "eds-image-uploader__dropzone-description eds-text-bm",
    "data-spec": "image-uploader-description"
  }, content, errorContent));
};
/**
 * The element shown when the user is waiting for the file to upload
 */


var LoadingElement = function LoadingElement(_ref2) {
  var url = _ref2.url,
      progress = _ref2.progress,
      localLoadingElement = _ref2.localLoadingElement,
      errorContent = _ref2.errorContent;

  // For uploading local file to browser, show a simple default loading view
  // which looks exact like the dropzone but with an animated icon.
  if (progress === 0 && localLoadingElement) {
    return React.createElement("div", {
      "data-spec": "image-uploader-loading-element"
    }, localLoadingElement);
  }

  var content;
  /* local image preview loads asynchonously so there may not be an image available yet */

  if (url) {
    content = React.createElement(ObjectFitImage, {
      imageSrc: url,
      imageAlt: gettext('Uploaded image preview'),
      imageClassName: "eds-image-uploader__loading-image"
    });
  }

  return React.createElement("div", {
    className: "eds-image-uploader__loading",
    "data-spec": "image-uploader-loading-element"
  }, React.createElement("div", {
    className: "eds-image-uploader__loading-image-container"
  }, React.createElement("div", {
    className: "eds-image-uploader__loading-image"
  }, content), React.createElement("div", {
    className: "eds-image-uploader__loading-progress"
  }, React.createElement("div", {
    className: "eds-image-uploader__loading-progress-bar"
  }, React.createElement(ProgressIndicator, {
    style: "light",
    progress: progress,
    type: "determinate",
    shape: "circular"
  })), errorContent)));
};
/**
 * Component helper to show each error separately
 */


var ErrorOutput = function ErrorOutput(_ref3) {
  var errors = _ref3.errors;
  var errorElements = errors.map(function (error) {
    return React.createElement("div", {
      key: error
    }, error);
  });
  return React.createElement("div", {
    className: "eds-image-uploader__errors",
    "data-spec": "image-uploader-errors"
  }, errorElements);
};
/**
 * An drag-and-drop image uploader that shows a live file preview
 * while the file is uploading.
 * @extends PureComponent
 * @example
 * // <ImageUploader
 * //     imageAlt={gettext('Your Event Image')}
 * //     imageUrl="url_or_data_uri"
 * //     onRemove={func_to_disassociate_image_id}
 * //     onReceiveFile={func_that_uploads_and_returns_promise_that_resolves_with_image_url}
 * // />
 */


var ImageUploader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ImageUploader, _PureComponent);

  function ImageUploader(props, context) {
    var _this;

    _classCallCheck(this, ImageUploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageUploader).call(this, props, context));
    _this.state = {
      previewImageUrl: props.imageUrl,
      errors: undefined,
      progressImageUrl: undefined,
      progress: undefined
    };
    return _this;
  }

  _createClass(ImageUploader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var imageUrl = nextProps.imageUrl; // the implementer should manage whether the uploader is populated.
      // this is important in the context of a form field whose populated state
      // could be for any number of reasons such as form reset, etc

      this.setState({
        previewImageUrl: imageUrl
      });
    }
  }, {
    key: "_handleRemoveFile",
    value: function _handleRemoveFile() {
      var onRemove = this.props.onRemove;
      this.setState({
        previewImageUrl: undefined
      });
      onRemove();
    }
  }, {
    key: "_validateFile",
    value: function _validateFile(file) {
      var _this$props = this.props,
          maxFileSize = _this$props.maxFileSize,
          _this$props$allowedCo = _this$props.allowedContentTypes,
          allowedContentTypes = _this$props$allowedCo === void 0 ? [] : _this$props$allowedCo,
          contentTypeError = _this$props.contentTypeError;
      var errors = [];

      if (maxFileSize && !isFileSizeValid(file, mbToBytes(maxFileSize))) {
        errors.push(gettext('The maximum size allowed is %(maxFileSize)sMB.  Please resize your image and try again.', {
          maxFileSize: maxFileSize
        }));
      }

      if (allowedContentTypes.length && !isFileTypeValid(file, allowedContentTypes)) {
        errors.push(contentTypeError);
      }

      if (errors.length) {
        this.setState({
          errors: errors
        });
        return false;
      }

      return true;
    }
  }, {
    key: "_handleReceiveFile",
    value: function _handleReceiveFile(file) {
      var _this$props2 = this.props,
          onReceiveFile = _this$props2.onReceiveFile,
          onUploadStatusChange = _this$props2.onUploadStatusChange;

      if (!this._validateFile(file)) {
        return Promise.reject();
      }

      this.setState({
        progress: 0,
        errors: undefined
      });

      if (onUploadStatusChange) {
        onUploadStatusChange(UPLOAD_STATUS_UPLOADING);
      }

      this._loadProgressImage(file);

      var promise = onReceiveFile(file, this._handleProgress.bind(this));

      if (!isPromise(promise)) {
        throw new Error('ImageUploader.onReceiveFile prop should return a promise');
      }

      return promise.then(this._handleUploadSuccess.bind(this)).catch(this._handleUploadFailure.bind(this));
    }
  }, {
    key: "_loadProgressImage",
    value: function _loadProgressImage(file) {
      loadImageFileDataURL(file).then(this._handleProgressImageLoaded.bind(this)).catch(noop);
    }
  }, {
    key: "_handleProgressImageLoaded",
    value: function _handleProgressImageLoaded(progressImageUrl) {
      var _this2 = this;

      var onProgressImageLoaded = this.props.onProgressImageLoaded;
      this.setState({
        progressImageUrl: progressImageUrl
      });

      if (onProgressImageLoaded) {
        var result = onProgressImageLoaded(progressImageUrl);

        if (isPromise(result)) {
          /**
           * This allows implementing parties to have control over the image shown
           * while uploading.  This is intially useful for integrating ImageCropper.
           * The user can crop the image prior to upload then dictate what's shown
           * during upload (such as a cropped version of the image).
           */
          result.then(function (modifiedProgressImageUrl) {
            _this2.setState({
              progressImageUrl: modifiedProgressImageUrl
            });
          });
        }
      }
    }
  }, {
    key: "_handleUploadSuccess",
    value: function _handleUploadSuccess(previewImageUrl) {
      var onUploadStatusChange = this.props.onUploadStatusChange;
      this.setState({
        previewImageUrl: previewImageUrl,
        errors: undefined,
        progressImageUrl: undefined,
        progress: undefined
      });

      if (onUploadStatusChange) {
        onUploadStatusChange(UPLOAD_STATUS_SUCCESS);
      }
    }
  }, {
    key: "_handleUploadFailure",
    value: function _handleUploadFailure(errorMessage) {
      var onUploadStatusChange = this.props.onUploadStatusChange;
      var errors;
      /**
       * Errors should be explicitly passed by implementer.
       * The implementer has control of the actual file transport, therefore
       * they have all knowledge of what failure occurred (validation
       * failures are handled separately in this file).
       * This also allows cancelling for other reasons, such as user driven
       * which should not display an error message.
       */

      if (errorMessage) {
        errors = [errorMessage];
      }

      this.setState({
        previewImageUrl: undefined,
        errors: errors,
        progressImageUrl: undefined,
        progress: undefined
      });

      if (onUploadStatusChange) {
        onUploadStatusChange(UPLOAD_STATUS_FAILED);
      }
    }
  }, {
    key: "_handleProgress",
    value: function _handleProgress(progress) {
      this.setState({
        progress: progress
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          imageAlt = _this$props3.imageAlt,
          headline = _this$props3.headline,
          description = _this$props3.description,
          iconType = _this$props3.iconType,
          onCrop = _this$props3.onCrop;
      var _this$state = this.state,
          previewImageUrl = _this$state.previewImageUrl,
          progressImageUrl = _this$state.progressImageUrl,
          progress = _this$state.progress,
          errors = _this$state.errors;
      var errorContent;

      if (errors && errors.length) {
        errorContent = React.createElement(ErrorOutput, {
          errors: errors
        });
      }

      var dropzone = React.createElement(DropzoneElement, {
        headline: headline,
        description: description,
        iconType: iconType,
        errorContent: errorContent
      });
      var dragDropzone = React.createElement(DropzoneElement, {
        headline: headline,
        description: description,
        iconType: iconType,
        isActive: true
      });
      var preview = React.createElement(PreviewElement, {
        url: previewImageUrl,
        altText: imageAlt,
        onRemove: this._handleRemoveFile.bind(this),
        onCrop: onCrop
      });
      var localLoadingElement = React.createElement(DropzoneElement, {
        headline: headline,
        description: description,
        iconType: iconType,
        iconAnimated: true,
        errors: errors
      });
      var loading = React.createElement(LoadingElement, {
        url: progressImageUrl,
        progress: progress,
        localLoadingElement: localLoadingElement,
        errorContent: errorContent
      });
      return React.createElement("div", {
        className: "eds-image-uploader"
      }, React.createElement(UploaderLayoutManager, {
        dropzoneElement: dropzone,
        dragDropzoneElement: dragDropzone,
        windowDragDropzoneElement: dragDropzone,
        loadingElement: loading,
        previewElement: preview,
        showPreview: !!previewImageUrl,
        onReceiveFile: this._handleReceiveFile.bind(this)
      }));
    }
  }]);

  return ImageUploader;
}(PureComponent);

_defineProperty(ImageUploader, "propTypes", {
  /**
   * Function that's invoked when the user clicks "Remove"
   */
  onRemove: PropTypes.func.isRequired,

  /**
   * Function that's invoked when the user has chosen a file
   */
  onReceiveFile: PropTypes.func.isRequired,

  /**
   * Alt attribute assigned to the image preview after image is uploaded.
   * This should be helpful, descriptive text that accurate represents
   * the purpose or meaning of the image (such as "Event Listing Image")
   */
  imageAlt: EBPropTypes.translation.isRequired,

  /**
   * Function that's invoked when the user clicks "Crop" button.
   * The "Crop" button is optional will only appear if this
   * function is provided.
   */
  onCrop: PropTypes.func,

  /**
   * URL of prepopulated image to be shown in the preview
   */
  imageUrl: PropTypes.string,

  /**
   * Primary text shown in the initial uploader state.
   * This should be a call-to-action to the user ("Choose an Image")
   */
  headline: PropTypes.node,

  /**
   * Secondary text shown in the initial uploader state.
   * This can be longer descriptive text to help the user choose an appropriate image.
   */
  description: PropTypes.node,

  /**
   * Icon shown above the headline in the initial uploader state.
   */
  iconType: ICON_TYPE_PROP_TYPE,

  /**
   * The maximum acceptable filesize specified in megabytes.
   * Files larger than this number will be rejected with an error message.
   */
  maxFileSize: PropTypes.number,

  /**
   * A list of acceptable content-types for dropped files.
   * Files of any type other than those in this list will be rejected with an error message.
   */
  allowedContentTypes: PropTypes.arrayOf(PropTypes.string),

  /**
   * The error message shown to the user if they drop an inappropriate filetype.
   * This can be specified via props to provide a more specific actionable message
   * such as "Please choose a JPG, PNG, or GIF"
   */
  contentTypeError: EBPropTypes.translation,

  /**
   * Function that's invoked when the "progress image" has loaded.  "Progress image"
   * is the image shown to the user while the image is being uploaded.  Your callback
   * will be provided a dataURI of the progress image.  If your onProgressImageLoaded
   * returns a promise, the result of the promise will be shown to the user while image
   * is being uploaded.  This gives the implementer some control over the progress image.
   */
  onProgressImageLoaded: PropTypes.func,

  /**
   * Function that's invoked when the user has chosen a file and returns
   * the status of the Uploader process of uploading.
   * Returns 3 possibles strings: 'uploading', 'uploaded', 'failed'.
   */
  onUploadStatusChange: PropTypes.func
});

_defineProperty(ImageUploader, "defaultProps", {
  headline: lazyGettext('Add Image'),
  description: lazyGettext('Drag-drop or click here to choose a file'),
  iconType: React.createElement(PhotoSvg, null),
  maxFileSize: 10,
  allowedContentTypes: defaultAllowedContentTypes,
  contentTypeError: lazyGettext('The selected file is not a valid type')
});

export { ImageUploader as default };